<template>
  <page-wrap>
    <layout-scroll-content :isLoading="isLoading" class="white-background" style="position: relative">
      <div class="row">
        <div class="col-xl-8 col-12 order-2 order-xl-1">
          <div
            class="quick-rfq__step"
            v-for="step in showedStepList"
            :key="step.index"
          >
            <component
              :disabledEmployee="!isVisibleAddToQuote"
              :is="step.componentName"
              :title="L10n(step.labelKey)"
              :isValid="step.isValid"
              @update:isValid="changeStepData(step.index, { isValid: $event })"
              :showButton="step.showButton"
              :eventID="eventID"
              :moduleName="moduleName"
              @command="controller($event, step)"
              :data="dataRFQ"
              :model="modelRFQ"
              :fieldPO="fieldPO"
              @onAutoSave="mixAutoSave"
              @onUpdatePO="handleUpdatePO"
            ></component>
          </div>
        </div>
        <div class="col-xl-4 col-12 order-1 order-xl-2 vb-xl">
          <!-- RFQ INFO -->
          <info-data-rfq v-if="currentStep > 1" :data="dataRFQ" />
          <el-button
            v-if="dataRFQ.customerCompanyID"
            type="primary"
            plain
            @click="openCustomerRemainder"
            :style="{ width: '100%' }"
          >
            {{L10n('show-customer-reminder')}}
          </el-button>
          <!-- PARTS INFO -->
          <info-section-parts
            v-if="currentStep > 1"
            :listRFQ1="listRFQ1"
            :mapListRFQ3="mapListRFQ3"
            @onAddToRFQ3="openDialogAddToRFQ3"
            @onSend="sendQuoteToCustomerEmailPart"
            @onSendFollowup="sendQuoteFollowUp"
          />
          <!-- QUOTES INFO -->
          <info-data-rfq3
            v-if="currentStep > 2"
            :rfqID="dataRFQ.id"
            :data="listRFQ3"
            :partIDs="partIDs"
            @onMultiple="handleCheckMultipleQuote"
            @onSendMultiple="sendQuoteMultiParts">
            <template v-slot:controls={row}>
              <button
                class="btn btn-size-xs"
                @click="sendQuoteToCustomerEmail(row, false)"
              >{{L10n('send-quote-to-customer-email')}}</button>
              <button
                class="btn btn-size-xs"
                @click="sendQuoteToCustomerEmail(row, true)"
              >{{L10n('send-quote-no-stock-to-customer-email')}}</button>
              <hr style="width: 100%">
            </template>
          </info-data-rfq3>
          <!-- RFQ INFO -->
          <info-data-rfq :title="L10n('po')" v-if="currentStep > 3" :data="dataRFQ" :model="modelInfoPo">
            <template v-slot:header>
              <span class="title">{{L10n('po')}}: </span> <span>{{fieldPO}}</span>
            </template>
          </info-data-rfq>
        </div>
      </div>
      <button
        v-if="currentStep >= 3"
        type="button"
        class="btn btn-size-s btn-new-rfq"
        @click="handlerNewRFQ"
      >
        {{L10n('new-rfq')}}
      </button>
    </layout-scroll-content>
    <!-- DIALOGS -->
    <dialog-add-to-rfq3
      :isLoading="isLoading"
      ref="dialog-add-to-rfq3"
    ></dialog-add-to-rfq3>
    <dialog-confirm
      ref="dialog-confirm-create-new-rfq"
      :config="{
        title: L10n('new-rfq'),
        text: L10n('create-new-rfq-from-stretch')
      }"
      @confirm="handlerConfirmCreateNewRFQ"
    >
      <template v-slot:footer-confirm="confirmProps">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s"
          @click.prevent="confirmProps.clickHandler('cancel')">
          {{L10n('cancel')}}
        </button>
        <button
          type="button"
          class="btn btn-control btn-border blue btn-size-s"
          ref="btnConfirm"
          @click.prevent="confirmProps.clickHandler('confirm')">
          {{L10n('confirm')}}
        </button>
      </template>
    </dialog-confirm>
    <dialog-send-quote-to-customer-email
      ref="dialogSendQuote"
      :rfqID="dataRFQ.id"
      :rfq3ID="dataRFQ3Send.id"
      @onSuccess="handlerSuccessCustomerEmail"
    />
    <dialog-send-quote-to-customer-email-part
      ref="dialogSendQuotePart"
      :rfqID="dataRFQ.id"
    />
    <dialog-send-quote-multi-parts
      ref="dialogSendQuoteMultiParts"
      :rfqID="dataRFQ.id"
      :partIDs="partIDs"
      @onSuccess="handlerSuccessCustomerEmail"
    />
    <dialog-reminder-table :title="L10n('reminder-table')" ref="dialogCustomerRemainder" :companyID="dataRFQ.customerCompanyID" />
  </page-wrap>
</template>

<script>
import StoreModule from './StoreModule'
import { ModelRFQNew, ModelRFQ1New, ModelRFQ3New, ModelRFQPO } from './models'
import { ModelInfoPOShort, ModelRFQs } from '@/services/RFQs'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'QuickIndexRFQ',
  mixins: [AutoSaveMixin],
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'main-rfq': () => import(/* webpackChunkName: 'QuickRFQ' */ './FormRFQ.vue'),
    'add-to-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQAddToRFQ3/Index.vue'),
    'list-customer-quotes': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ListCustomerQuotes/Index.vue'),
    'po-form-rfq': () => import(/* webpackChunkName: 'QuickRFQ' */ './FormPO.vue'),
    'info-data-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ3'),
    'info-data-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ'),
    'info-section-po': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionPO'),
    'info-section-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionParts'),
    'dialog-add-to-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/Index'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogConfirm'),
    'dialog-send-quote-multi-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/DialogSendQuoteMultiParts'),
    'dialog-send-quote-to-customer-email': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SendQuoteToCustomerEmail/Index'),
    'dialog-send-quote-to-customer-email-part': () => import(/* webpackChunkName: 'QuickRFQ' */ '@/components/Shared/DialogSendEmailToCustomerByPart'),
    'dialog-reminder-table': () => import(/* webpackChunkName: 'DialogRemainderTable' */ '@/components/Shared/DialogRemainderTable')
  },
  created () {
    const store = this.$store
    const moduleName = this.moduleName
    if (store && !store.state[moduleName]) {
      store.registerModule(moduleName, StoreModule)
    }
  },
  beforeDestroy () {
    this.$store.dispatch(`${this.moduleName}/resetState`)
  },
  data () {
    return {
      moduleName: 'quick-rfq',
      eventID: 'quick-rfq',
      dataRFQ3Send: {},
      isLoadingNew: false
    }
  },
  computed: {
    apiAutoSave () {
      return `RFQs/Patch/${this.dataRFQ.id}`
    },
    isAvailableToSave () {
      return this.currentStep > 1
    },
    isVisibleAddToQuote () {
      const permissions = this.$store.getters.get('permissions')
      return this.permission(permissions, 'isAllowToViewQuickRFQByParts')
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    showSendCustomerButton () {
      return this.listRFQ3.some(({ chosen }) => chosen)
    },
    mapListRFQ3 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ3`]
    },
    isLoading () {
      return this.$store.state[this.moduleName].isLoading || this.isLoadingNew
    },
    currentStep () {
      return this.$store.state[this.moduleName].currentStep
    },
    dataRFQ () {
      return this.$store.state[this.moduleName].dataRFQ
    },
    fieldPO () {
      return this.$store.state[this.moduleName].fieldPO
    },
    listRFQ1 () {
      return this.$store.state[this.moduleName].listRFQ1
    },
    listRFQ3 () {
      return this.$store.state[this.moduleName].listRFQ3
    },
    showedStepList () {
      return this.$store.getters[`${this.moduleName}/showedStepList`]
    },
    partIDs () {
      return this.listRFQ3
        .filter(({ _includeMultiple }) => !!_includeMultiple)
        .map(({ partID }) => partID)
    }
  },
  methods: {
    openCustomerRemainder () {
      const dialog = this.$refs['dialogCustomerRemainder']
      if (!dialog) return

      dialog.show()
    },
    handleCheckMultipleQuote (value, row) {
      this.$store.dispatch(`${this.moduleName}/checkMultipleRFQ3`, { value, data: row })
    },
    modelInfoPo () {
      return ModelInfoPOShort()
    },
    modelRFQ () {
      return ModelRFQs()
    },
    controller (command, { isValid }) {
      if (command === 'created-rfq') {
        this.changeStepData(1, { showButton: false })
        this.setCurrentStep(2)
      }
      if (command === 'came-list-rfq-1') {
        if (isValid && !this.listRFQ3.length) {
          this.setCurrentStep(2)
        }
      }
      if (command === 'add-to-rfq-3') {
        this.setCurrentStep(3)
      }
      if (command === 'came-list-rfq-3') {
        if (!this.listRFQ3.length) {
          this.setCurrentStep(2)
          this.changeStepData(3, { showButton: true })
        } else if (this.currentStep <= 3) {
          this.changeStepData(3, { showButton: true })
        }
      }
      if (command === 'show-po') {
        this.setCurrentStep(4)
        this.changeStepData(3, { showButton: false })
      }
      if (command === 'hide-po') {
        this.setCurrentStep(3)
        this.changeStepData(3, { showButton: true })
      }
      if (command === 'mounted-po') {
        this.changeStepData(3, { showButton: false })
      }
    },
    changeStepData (stepIndex, value) {
      this.$store.dispatch(`${this.moduleName}/changeStepData`, { step: stepIndex, value })
    },
    setCurrentStep (value) {
      this.$store.dispatch(`${this.moduleName}/setCurrentStep`, { value })
    },
    openDialogAddToRFQ3 (dataRFQ1) {
      let dialog = this.$refs['dialog-add-to-rfq3']
      dialog.open(dataRFQ1, (data) => {
        this.handlerAddRFQ1ToRFQ3(data)
          .then(() => {
            dialog.close()
            this.requestSuccessHandler()
            this.controller('add-to-rfq-3', {})
          })
          .catch((err) => {
            this.requestErrorHandler(err)
          })
      })
    },
    sendQuoteToCustomerEmail (data, noStock) {
      this.dataRFQ3Send = { ...data }
      this.$nextTick(() => {
        this.$refs.dialogSendQuote.show({ noStock })
      })
    },
    sendQuoteFollowUp (data) {
      this.dataRFQ3Send = { ...data }
      this.$nextTick(() => {
        this.$refs.dialogSendQuote.show({ isFollowUp: true })
      })
    },
    sendQuoteMultiParts (logoType) {
      this.$refs.dialogSendQuoteMultiParts.show({ logoType })
    },
    sendQuoteToCustomerEmailPart (dataRFQ1) {
      const { id } = dataRFQ1
      this.$nextTick(() => {
        this.$refs.dialogSendQuotePart.show({ id })
      })
    },
    handlerSuccessCustomerEmail () {
      this.$bus.$emit(`refresh-data-${this.eventID}`)
    },
    /**
     * @desc Add new RFQ1 to RFQ3
     * @param data { Object } - Data for RFQ3
     * @async
     * @return {Promise}
     */
    handlerAddRFQ1ToRFQ3 (data) {
      return this.$store.dispatch(`${this.moduleName}/addRFQ1ToRFQ3`, data)
        .then(() => {
          this.$bus.$emit(`refresh-data-${this.eventID}`)
        })
    },
    validate () {
      return new Promise((resolve, reject) => {
        let isValid = this.showedStepList.every(({ isValid }) => {
          return isValid
        })
        if (isValid) {
          resolve()
        } else {
          reject(new Error(this.L10n('validate-error')))
        }
      })
    },
    handlerNewRFQ () {
      return this.validate()
        .then(() => {
          this.$refs['dialog-confirm-create-new-rfq'].show()
        })
        .catch((err) => {
          this.requestErrorHandler(err, err.message)
        })
    },
    handlerConfirmCreateNewRFQ () {
      return this.validate()
        .then(() => {
          return this.processCreateNewRFQ()
        })
        .catch((err) => {
          this.requestErrorHandler(err, err.message)
        })
    },
    processCreateNewRFQ () {
      this.isLoadingNew = true
      let oldDataRFQ = { ...this.dataRFQ }
      delete oldDataRFQ['rfqid']
      let dataRFQ = this.copyObjectProps(new ModelRFQNew(this.$root, this.$store), oldDataRFQ)
      let dataListRFQ1 = this.listRFQ1.map((item) => {
        return this.copyObjectProps(new ModelRFQ1New(this.$root, this.$store), item)
      })
      let dataListRFQ3 = this.listRFQ3.map((item) => {
        return this.copyObjectProps(new ModelRFQ3New(this.$root, this.$store), item)
      })
      let dataPO = this.copyObjectProps(new ModelRFQPO(this.$root, this.$store), oldDataRFQ)
      let completeStep = 0
      // Reset State
      return this.$store
        .dispatch(`${this.moduleName}/resetState`, dataRFQ)
        .then(() => {
          this.setCurrentStep(0)
        })
        // Create RFQ (First Step)
        .then(() => {
          return this.$store
            .dispatch(`${this.moduleName}/createRFQ`, dataRFQ)
            .then((data) => {
              const label = this.L10n('success-create-rfq')
              this.requestSuccessHandler(label)
              this.changeStepData(1, { showButton: false })
              completeStep++
              return data
            })
        })
        // Create RFQ1 list (second step)
        .then(({ rfqid }) => {
          return Promise
            .all(dataListRFQ1.map((item) => {
              return this.$store.dispatch(`${this.moduleName}/createRFQ1`, { ...item, rfqid })
            }))
            .then(() => {
              const label = this.L10n('success-create-rfq-1-list')
              this.requestSuccessHandler(label)
              completeStep++
              this.changeStepData(2, { showButton: false })
              return { rfqid }
            })
        })
        // Create RFQ3 list (third step)
        .then(({ rfqid }) => {
          return Promise.all(dataListRFQ3.map((item) => {
            return this.$store.dispatch(`${this.moduleName}/addRFQ1ToRFQ3`, { ...item, rfqid })
          }))
            .then(() => {
              const label = this.L10n('success-create-rfq-3-list')
              this.requestSuccessHandler(label)
              completeStep++
              this.changeStepData(3, { showButton: false })
              return { rfqid }
            })
        })
        // Create PO
        .then(() => {
          // Po is not created
          if (!oldDataRFQ.po) {
            return Promise.resolve()
          }
          return this.$store
            .dispatch(`${this.moduleName}/createPO`, dataPO)
            .then((data) => {
              const label = this.L10n('success-create-po')
              this.requestSuccessHandler(label)
              completeStep++
              this.changeStepData(3, { showButton: false })
              return data
            })
        })
        .catch((err) => {
          this.requestErrorHandler(err, err.message)
        })
        .then(() => {
          this.isLoadingNew = false
          this.setCurrentStep(Math.max(1, completeStep))
        })
    },
    handleUpdatePO (value) {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'fieldPO', value })
    },
    // FROM MIXIN AUTO SAVE
    mixSuccessAutoSave (data) {
      this.$store.commit(`${this.moduleName}/UPDATE`, { key: 'dataRFQ', value: data })
    },
    mixErrorAutoSave () {
      this.$store.commit(`${this.moduleName}/UPDATE`, { key: 'dataRFQ', value: {} })
    }
  }
}
</script>

<style lang="stylus">
  .page-RFQQuickRFQ{
    .btn-new-rfq{
      position absolute
      top 0
      right 0
    }
  }
  .quick-rfq__step{
    margin-bottom 2rem
  }
</style>
